import { POST, PUT, DELETE } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import companyGroupEndpoints from '../api/companyGroupEndpoints'
import { Company } from '../../../types/company/Company'

export interface SubsidiaryOrder {
  companyId?: string | null
  subsidiaryId: Company['id']
  order: number
}

export const addSubsidiaries = async (companyId: string, data: Partial<Company>[]): Promise<Company[]> => {
  return backendRequest<Company[]>({
    method: POST,
    url: companyGroupEndpoints.subsidiaries(companyId),
    data
  })
}

export const updateSubsidiaryAcquisitions = async (companyId: string, data: Company): Promise<Company> => {
  return backendRequest<Company>({
    method: PUT,
    url: companyGroupEndpoints.subsidiaryAcquisitions(companyId, data.id),
    data
  })
}

export const deleteSubsidiary = async (companyId: string, subsidiaryId: Company['id']): Promise<Company[]> => {
  return backendRequest<Company[]>({
    method: DELETE,
    url: companyGroupEndpoints.subsidiaryDetail(companyId, subsidiaryId)
  })
}

export const updateSubsidiaryOrders = async (companyId: string, data: SubsidiaryOrder[]): Promise<void> => {
  return backendRequest<void>({
    method: PUT,
    url: companyGroupEndpoints.subsidiaryOrder(companyId),
    data
  })
}
